import { render, staticRenderFns } from "./MasterCustomer.vue?vue&type=template&id=851143fe&scoped=true&"
import script from "./MasterCustomer.vue?vue&type=script&lang=js&"
export * from "./MasterCustomer.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=851143fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "851143fe",
  null
  
)

export default component.exports